import React from 'react';

import { useContactBar } from '../../utils/hooks/useContactBarHook';

const PaymentFailure: React.FC = () => {
  useContactBar();

  return (
    <p className="m-auto text-lg overflow-auto text-center">
      Your card details were successfully updated.
    </p>
  );
};

export default PaymentFailure;
